import { render, staticRenderFns } from "./PrivacyPolicyPopup.vue?vue&type=template&id=0f6f93db&scoped=true"
import script from "./PrivacyPolicyPopup.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPopup.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyPopup.vue?vue&type=style&index=0&id=0f6f93db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f93db",
  null
  
)

export default component.exports